module.exports = __webpack_public_path__ + "img/CheckinIcon.d6d00301.svg";